import React from 'react';
import { InputGroup, FormControl, Button } from 'react-bootstrap';
import { BsSearch } from 'react-icons/bs';

const SearchBar = (props) => {
    const style = {
        button: {
            // borderRadius: "50px",
        },
        input: {
            borderRadius: "30px",
            fontWeight: "300",
            fontSize: "14px",
            textTransform: "capitalize",
            color: "gray"
        },
    }

    return (
        <InputGroup className="mb-3 search-form" style={{ width: props.width }}>
            <FormControl
                placeholder={props.placeholder}
                style={style.input}
                className="search-input"
            />
            <InputGroup.Append>
                <Button
                    variant="outline-secondary"
                    onClick={props.onClick}
                    style={style.button}
                    className="search-btn"
                >
                    <BsSearch />
                </Button>
            </InputGroup.Append>
        </InputGroup>
    )
};

export default SearchBar;
